import { useGetFormData } from 'cng-common/features/form'
import { IKeyInitiativesControlsForm } from 'partner360/features/keyInitiatives/model/types'

import { KEY_INITIATIVE_CONTROLS_FORM } from '../../configs/config'

export const useKeyInitiativesControlsForm = () => {
  const [{ formData }] = useGetFormData<IKeyInitiativesControlsForm>(KEY_INITIATIVE_CONTROLS_FORM)

  return { groupBy: formData.groupBy, chartMeasure: formData.chartMeasure }
}
